import { NgModule } from '@angular/core';
import { NgClass } from '@angular/common';

import { ButtonComponent } from './button.component';
import { ButtonDirective } from './button.directive';

/**
 * Angular module providing button components and directives with consistent styling.
 *
 * @remarks
 * Exports {@link ButtonComponent} for standalone button elements and {@link ButtonDirective}
 * for applying button styling to existing button elements. Both components support various
 * color schemes, sizes, and accessibility features with Bootstrap-based CSS integration.
 *
 * @example
 *
 * ```typescript
 * import { ButtonModule } from '@backbase/ui-ang/button';
 *
 * @NgModule({
 *   imports: [ButtonModule],
 *   // ... other module configuration
 * })
 * export class FeatureModule {}
 * ```
 */
@NgModule({
  imports: [NgClass],
  declarations: [ButtonComponent, ButtonDirective],
  exports: [ButtonComponent, ButtonDirective],
})
export class ButtonModule {}
